import './instrumentation/sentry'
import { configure } from '@paytrie/client'
import * as Sentry from '@sentry/react'
import { createRoot } from 'react-dom/client'

import App from './App.tsx'

import './index.css'
import { getApiBaseUrl } from './utils/api'

configure({
  baseUrl: getApiBaseUrl(),
})

const container = document.getElementById('root')

createRoot(container, {
  onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
    console.warn('Uncaught error', error, errorInfo.componentStack)
  }),
  // Callback called when React catches an error in an ErrorBoundary.
  onCaughtError: Sentry.reactErrorHandler(),
  // Callback called when React automatically recovers from errors.
  onRecoverableError: Sentry.reactErrorHandler(),
}).render(<App />)
